import React from 'react';
import about from '../../assets/images/about_us.jpg';

const AboutUs = () => (
    <div>
        <img src={about} className="mt-5" alt="about us" />
    </div>
);

export default AboutUs;